import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'flex-center pointer-events-auto absolute top-8 size-8 cursor-pointer rounded-full bg-white shadow-[0px_4px_11px_0px_#1D1F221A] disabled:hidden',
    icon: ''
  },
  variants: {
    direction: {
      prev: {
        base: 'left-0',
        icon: 'rotate-180'
      },
      next: {
        base: 'right-0'
      }
    }
  }
});
